import { gql, useMutation } from '@apollo/client';

import { GET_VACANCIES } from './get-vacancies.hook';

export const DELETE_VACANCY_BY_ID = gql`
  mutation deleteVacancyById($vacancyId: ObjectId!) {
    deleteVacancyById(vacancyId: $vacancyId)
  }
`;

export const useDeleteVacancyById = () => {
  const [deleteVacancy] = useMutation(DELETE_VACANCY_BY_ID, {
    refetchQueries: [GET_VACANCIES],
  });

  return { deleteVacancy };
};
